/* eslint-disable @next/next/no-img-element */
import { RefereeListItemFragment } from '@amf/shared/types/graphql';
import React from 'react';
import { getInitials } from '@amf/shared/utils/string';
import { useTranslate } from '@tolgee/react';
import Link from 'next/link';

interface Props {
  referee: RefereeListItemFragment;
  link: string;
}

function RefereeListItem({ referee, link }: Props) {
  const { t } = useTranslate();
  return (
    <Link href={`${link}/${referee.id}`} passHref>
      <a className='RefereeListItem'>
        <div className='RefereeListItem__photo'>
          {referee.photoUrl && <img src={referee.photoUrl} alt={referee.fullName} />}
          {!referee.photoUrl && <div>{getInitials(referee.givenName, referee.familyName)}</div>}
        </div>
        <div className='RefereeListItem__info'>
          <h3 className='RefereeListItem__name'>
            {referee.fullName} <span>{referee.amfId}</span>
          </h3>
          <div className='RefereeListItem__about'>
            <span>Licence: {t(`referee.license.${referee.license}`)}</span>
          </div>
        </div>
      </a>
    </Link>
  );
}

export default RefereeListItem;
